module.exports = __webpack_public_path__ + "static/media/10.6fcb0df9.jpg";